var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "div",
        { staticClass: "v-height-flag" },
        [
          _vm.fileData && _vm.fileData.length > 0
            ? [
                _c("div", { staticClass: "first-header" }, [
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          key: 0,
                          attrs: {
                            disabled: _vm.fileData.length <= 0,
                            label: 0,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.checkChange(1)
                            },
                          },
                          model: {
                            value: _vm.menuIds,
                            callback: function ($$v) {
                              _vm.menuIds = $$v
                            },
                            expression: "menuIds",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.checked
                                  ? _vm.$t("file.reverse")
                                  : _vm.$t("file.all")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fileStyle.style === 1
                    ? _c("p", [_vm._v("文件大小")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileStyle.style === 1
                    ? _c("p", [_vm._v("创建人")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileStyle.style === 1
                    ? _c("p", [_vm._v(_vm._s(_vm.$t("file.updatetime")))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fileStyle.style === 1
                    ? _c("p", [_vm._v("操作")])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "v-height-flag", attrs: { id: "listview" } },
                  [
                    _c(
                      "div",
                      { directives: [{ name: "height", rawName: "v-height" }] },
                      [
                        _c(
                          "el-scrollbar",
                          { staticStyle: { height: "100%" } },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "public-ul",
                                class:
                                  _vm.fileStyle.style === 1
                                    ? "content-ul"
                                    : "infeed-ul",
                              },
                              _vm._l(_vm.fileData, function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    class: _vm.menuIds.includes(item.id)
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "content-left pointer" },
                                      [
                                        _c("el-checkbox", {
                                          key: item.id,
                                          style: {
                                            display: _vm.menuIds.includes(
                                              item.id
                                            )
                                              ? "block"
                                              : "none",
                                          },
                                          attrs: { label: item.id },
                                          on: {
                                            change: function ($event) {
                                              return _vm.checkChange(2)
                                            },
                                          },
                                          model: {
                                            value: _vm.menuIds,
                                            callback: function ($$v) {
                                              _vm.menuIds = $$v
                                            },
                                            expression: "menuIds",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.renameIndex !== index
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "public-title",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.itemCheckChange(
                                                      item
                                                    )
                                                  },
                                                  dblclick: function ($event) {
                                                    return _vm.getItemFile(item)
                                                  },
                                                  contextmenu: function (
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                    $event.stopPropagation()
                                                    return _vm.rightClick(
                                                      $event,
                                                      item,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm.fileStyle.style == 2
                                                  ? [
                                                      item.type == 1
                                                        ? _c("img", {
                                                            staticClass:
                                                              "folder",
                                                            attrs: {
                                                              alt: "",
                                                              src: require("../../../../../assets/images/cloud/file.png"),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      item.type !== 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "file",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "." +
                                                                  _vm._s(
                                                                    item.file_ext
                                                                  )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.file_ext
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "over-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name) +
                                                            "." +
                                                            _vm._s(
                                                              item.file_ext
                                                            )
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "over-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "p",
                                              { staticClass: "public-title" },
                                              [
                                                _vm.fileIsImage("image/jpegs")
                                                  ? _c("img", {
                                                      staticClass: "image",
                                                      attrs: {
                                                        src: item.file_url,
                                                      },
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "icon iconfont",
                                                      class: _vm.getFileType(
                                                        item.type,
                                                        item.file_url
                                                      ),
                                                    }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.name,
                                                      expression: "item.name",
                                                    },
                                                  ],
                                                  staticClass: "rename-input",
                                                  attrs: {
                                                    id: "input" + index,
                                                    placeholder:
                                                      _vm.$t(
                                                        "file.placeholder10"
                                                      ),
                                                    autofocus: "autofocus",
                                                    maxlength: "30",
                                                  },
                                                  domProps: {
                                                    value: item.name,
                                                  },
                                                  on: {
                                                    blur: function ($event) {
                                                      return _vm.renameBlur(
                                                        item
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        item,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.fileStyle.style === 1
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatBytesFn(item.file_size)
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.fileStyle.style === 1
                                      ? _c("div", [
                                          _c("img", {
                                            staticClass: "img",
                                            attrs: {
                                              src: item.user
                                                ? item.user.avatar
                                                : "",
                                              alt: "",
                                            },
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              item.user ? item.user.name : "--"
                                            ) + "\n                "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.fileStyle.style === 1
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.updated_at) +
                                              "\n                "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.fileStyle.style === 1
                                      ? _c(
                                          "div",
                                          { staticClass: "icon-star" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icon-star-right pointer",
                                              },
                                              [
                                                _c(
                                                  "el-popover",
                                                  {
                                                    ref: "pop-" + index,
                                                    refInFor: true,
                                                    attrs: {
                                                      offset: 30,
                                                      width: 40,
                                                      placement: "bottom-start",
                                                      trigger: "click",
                                                    },
                                                    on: {
                                                      "after-enter": function (
                                                        $event
                                                      ) {
                                                        return _vm.handleShow(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "right-item-list",
                                                      },
                                                      [
                                                        item.type !== 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.fileDownLoad(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "public.download"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.type !== 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.shareOther(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("分享")]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.type !== 1
                                                          ? _c("el-divider")
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "right-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.getMoveDialog(
                                                                  item,
                                                                  1
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "file.moveto"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        item.type === 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.addAuthor(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "file.directory"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.type !== 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.getMoveDialog(
                                                                        item,
                                                                        2
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "file.copyto"
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "right-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.setRenameItem(
                                                                  item,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "file.rename"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-divider"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "right-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.getFolderDelete(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "public.delete"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "right-item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.getFileAttribute(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "file.attribute"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("i", {
                                                      staticClass:
                                                        "icon iconfont icongengduo1",
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      slot: "reference",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("el-pagination", {
                              staticClass: "page-fixed",
                              attrs: {
                                "current-page": _vm.where.page,
                                "page-size": _vm.where.limit,
                                "page-sizes": [10, 15, 20],
                                total: _vm.total,
                                layout: "total, prev, pager, next, jumper",
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _c("default-page", {
                directives: [{ name: "height", rawName: "v-height" }],
                attrs: { index: 7, "min-height": 510 },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
      _vm._v(" "),
      _c("move-dialog", {
        ref: "moveDialog",
        attrs: { "move-data": _vm.moveData },
        on: { handlerMove: _vm.handlerMove },
      }),
      _vm._v(" "),
      _c("file-attribute", {
        ref: "fileAttribute",
        attrs: { "form-data": _vm.formBoxConfig },
      }),
      _vm._v(" "),
      _c("right-click", {
        ref: "rightClick",
        attrs: { "config-data": _vm.rightData },
        on: { handleRightClick: _vm.handleRightClick },
      }),
      _vm._v(" "),
      _c("author-dialog", {
        ref: "authorDialog",
        attrs: { "from-data": _vm.fromData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }